<div class="row" id="settings-translations">
  <div class="flex flex-col col-12 mb-4">
    <h2 data-testid="translation-settings-title">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TITLE'| translate }}</h2>
  </div>
  <div class="flex flex-col col-12 mb-4">
    <span data-testid="translation-settings-subtitle" class="block text-base">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.SUBTITLE'| translate }}</span>
  </div>
  <hr class="mb-1 mt-2 border-t">
  <form [formGroup]="translationsSettingsFormGroup">
    <section class="row">
      <div class="flex flex-col col-12 mt-1">
        <h3 data-testid="supported-languages">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.SUPPORTED_LANGUAGES' | translate }}</h3>
      </div>
      @for (language of languages; track language) {
        <div class="col-md-4 col-sm-6 mt-1 flex flex-row items-center gap-2">
          <p-checkbox [attr.data-testid]="'input-' + language.code" [inputId]="language.code" [formControlName]="language.code"
            [binary]="true" />
          <label [for]="language.code">{{ language.language }}</label>
        </div>
      }
      <hr class="w-full mt-5 mb-1 border-t">
      <div class="flex flex-col col-12">
        <h3 data-testid="default-language">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.SET_DEFAULT_LANG' | translate }}</h3>
      </div>
      <div class="field-wr flex flex-col col-12">
        <p data-testid="default-language-description">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.SET_DEFAULT_LANG_DESCRIPTION' | translate }}</p>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
        <label data-testid="language-label" class="block text-sm" for="language">{{ 'YOUR_ACCOUNT.LANGUAGE' | translate }}</label>
        <p-select
          inputId="languages-list"
          styleClass="dropdown"
          [options]="languages"
          optionLabel="language"
          optionValue="code"
          formControlName="defaultLang"
          placeholder="{{ 'YOUR_ACCOUNT.LANGUAGE_DROPDOWN_PLACEHOLDER' | translate }}"
          [showClear]="false">
          <ng-template pTemplate="label" let-item>
            {{ item.language }}
          </ng-template>
        </p-select>
      </div>
      <hr class="w-full mt-3 mb-1 border-t">
      <div class="flex flex-col col-12">
        <h3 data-testid="translation-mapping">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TRANSLATION_MAP' | translate }}</h3>
      </div>
      <div class="field-wr flex flex-col col-12">
        <p data-testid="translation-description">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TRANSLATION_MAP_DESCRIPTION' | translate }}</p>
      </div>
      <div class="flex flex-col col-12">
        <p-table #dtTranslationsTable [value]="translationsList">
          <ng-template #header>
            <tr>
              <th>
                <div data-testid="key-header" class="header-wr">
                  {{ 'SYSTEM_SETTINGS.TRANSLATIONS.TH_TRANSLATION_KEY' | translate }}
                </div>
              </th>
              <th>
                <div data-testid="system-header" class="header-wr">
                  <span class="col-name">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TH_SYSTEM_VALUE_EN' | translate }}</span>
                </div>
              </th>
              <th>
                <div data-testid="action-header" class="header-wr">
                  <span class="col-name">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TH_ACTIONS' | translate }}</span>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-translation let-rowIndex="rowIndex">
            <tr>
              <td>
                <span [attr.date-testid]="'key-' + rowIndex" class="p-column-title">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TH_TRANSLATION_KEY' | translate }}:</span>
                {{ translation.translationKey }}
              </td>
              <td>
                <span [attr.date-testid]="'value-' + rowIndex" class="p-column-title">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TH_SYSTEM_VALUE_EN' | translate }}:</span>
                {{ translation.systemValue }}
              </td>
              <td class="actions-col">
                <span class="p-column-title">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TH_ACTIONS' | translate }}:</span>
                <div class="flex gap-2">
                  <button type="button" pTooltip="{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TOOLTIP_EDIT_TRANSLATION' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-edit" (click)="openTranslationDetails($event, translation.id)" [attr.date-testid]="'action-' + rowIndex">
                      <span class="btn-label">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TOOLTIP_EDIT_TRANSLATION' | translate }}</span>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </section>
  </form>
  <!-- <hr class="w-full mb-6 mt-4 border-t"> -->
  <div class="col-12 mt-6 mb-4 pt-8 ">
    <div class="flex items-center justify-end gap-3">
      <button data-testid="update-translation-settings-btn" class="btn primary-btn" (click)="updateTranslationsSettings()">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.SAVE_CHANGES' | translate }}</button>
    </div>
  </div>
</div>


<!-- Modalbox: translation data -->
<p-dialog
  [header]="'MODALBOXES.TITLE_TRANSLATION_MAPPING' | translate"
  [(visible)]="displayTranslationDataModalbox"
  modal="true"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false">
  <div class="flex items-baseline gap-2">
    <span class="label">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.LABEL_TRANSLATION_KEY' | translate }}:</span>
    <span class="value">{{ translationKey }}</span>
  </div>
  <div class="flex items-baseline gap-2">
    <span class="label">{{ 'SYSTEM_SETTINGS.TRANSLATIONS.LABEL_SYSTEM_VALUE_EN' | translate }}:</span>
    <span class="value">{{ systemValue }}</span>
  </div>
  <hr role="presentation" class="w-full mt-4 mb-5 border-t">
  <p-table [value]="translationDetails">
    <ng-template #header>
      <tr>
        <th>{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TH_LANGUAGE' | translate }}</th>
        <th>{{ 'SYSTEM_SETTINGS.TRANSLATIONS.TH_TRANSLATION' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template #body let-translation>
      <tr>
        <td>
          <label data-testid="translation-label" class="block text-sm">{{ translation?.language }}</label>
        </td>
        <td>
          <input data-testid="translation-input" type="text" [(ngModel)]="translation.translation" autocomplete="off">
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template #footer>
    <div class="mt-6">
      <button data-testid="cancel-translation-btn" type="button" class="btn outline-btn" (click)="onCancelTranslationDetailsUpdate()">{{ 'MODALBOXES.BTN_CANCEL_TRANSLATION_UPDATE' | translate }}</button>
      <button data-testid="update-translation-btn" type="button" class="btn primary-btn" (click)="onUpdateTranslationDetails()">{{ 'MODALBOXES.BTN_SAVE_TRANSLATIONS' | translate }}</button>
    </div>
  </ng-template>
</p-dialog>
